<template>
    <div v-loading.fullscreen.lock="loading">
        <common-title-search-bar-component
            add_auth="新增公共考核标题"
            @search="get_common_title_index"
            @addTeam="addTeam"
        ></common-title-search-bar-component>
        <common-table-component
            details_auth="公共考核标题详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_common_title"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_common_title_index"
        ></common-page-component>
        <common-title-edit-component
            edit_auth="修改公共考核标题"
            del_auth="删除公共考核标题"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :common_title_details_data="fcommon_title_details_data"
            @exitDialog="dialogExit"
            @search="get_common_title_index"
            @show_edit="show_edit"
            @details_row="details_common_title"
        ></common-title-edit-component>
    </div>
</template>

<script>
import { common_title_index_request,common_title_details_request } from '@/network/kpi/CommonTitle.js'

import CommonTitleSearchBarComponent from '@/components/kpi/CommonTitle/CommonTitleSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import CommonTitleEditComponent from '@/components/kpi/CommonTitle/CommonTitleEditComponent'

export default {
    name: 'CommonTitleView',
    data() {
        return {
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: true,
            ftotal: 0,
            cond: {
                title: '',
                page: 1,
                limit: 10,
            },
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'title',
                    label: '公共考核标题名',
                    minWidth: '300px',
                },{
                    prop: 'create_time',
                    label: '创建时间',
                    minWidth: '120px',
                }
            ],
            fcommon_title_details_data: {},
        }
    },
    computed: {},
    methods: {
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        get_common_title_index(param = {}) {
            this.loading = true
            this.cond.title = param.title ?? this.cond.title
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            common_title_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_common_title(id) {
            this.fid = id
            this.fdialogFormVisible = true
            common_title_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.fcommon_title_details_data = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
    },
    filters: {},
    props: {},
    created() {
        this.get_common_title_index()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        CommonTitleSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        CommonTitleEditComponent
    },
    watch: {},
}
</script>

<style lang='less'></style>